$(document).ready(function(){
  $(document).on("click",".block__product-faq--que",function(){
    if($(this).parents(".block__product-faq--box").hasClass("change_icon")){
      $(this).parents(".block__product-faq--box").removeClass("change_icon");
     $(this).parents(".block__product-faq--box").find(".block__product-faq--aws").slideUp();
    }else{
      $(".block__product-faq--box").removeClass("change_icon");
      $(".block__product-faq--aws").slideUp();
      $(this).parents(".block__product-faq--box").addClass("change_icon");
      $(this).parents(".block__product-faq--box").find(".block__product-faq--aws").slideDown();
    }
  });
});